import React from 'react'

export default function Toast({ icon, headline, text }) {
  return (
    <div className="flex h-full bg-gray-900">
      <div className="bg-gray-800 flex items-center px-4">
        {icon}
      </div>
      <div className="flex-1 p-4">
        {headline && <p className="text-white font-medium">{headline}</p>}
        <p className="text-gray-300 text-xs leading-snug">{text}</p>
      </div>
    </div>
  )
}
